<app-header-component></app-header-component>
<app-sidebar-component></app-sidebar-component>
<div class="main-content" [ngClass]="{'open':toggleSideBar}" >
    <router-outlet></router-outlet>
</div>
